import { ActionBar, ButtonVariant, StyledFlex } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';

import { patientMedicalInformationTranslationKeys } from '../translations';

import { MedicalInformationAccordion } from './MedicalInformationAccordion';
import { MedicalInformationAccordionLoader } from './MedicalInformationAccordion.loader';
import { MedicalInformationAddEntryModalOpener } from './MedicalInformationAddEntry/MedicalInformationAddEntryModal.opener';
import { MedicalInformationShowRemovedCheckbox } from './MedicalInformationShowRemovedCheckbox';

type MedicalInformationPanelProps = Readonly<{ patientId: number }>;

export const MedicalInformationPanel = (props: MedicalInformationPanelProps): JSX.Element => {
   return (
      <>
         <StyledFlex gap={16} direction={'column'}>
            <MedicalInformationShowRemovedCheckbox />
            <MedicalInformationAccordionLoader patientId={props.patientId}>
               {({ medicalInformationCountByTypes }) => (
                  <MedicalInformationAccordion
                     patientId={props.patientId}
                     medicalInformationCountByTypes={medicalInformationCountByTypes}
                  />
               )}
            </MedicalInformationAccordionLoader>
         </StyledFlex>

         {protectFeature(
            'creatingPatientMedicalInformation',
            <MedicalInformationAddEntryModalOpener patientId={props.patientId}>
               {({ openModal }) => (
                  <ActionBar.PrimaryButton
                     testId={'addEntry'}
                     label={patientMedicalInformationTranslationKeys.addEntry}
                     onClick={openModal}
                     variant={ButtonVariant.PRIMARY}
                  />
               )}
            </MedicalInformationAddEntryModalOpener>
         )}
      </>
   );
};
